import { render, staticRenderFns } from "./EmailRendering.vue?vue&type=template&id=56d1e160&scoped=true&"
import script from "./EmailRendering.vue?vue&type=script&lang=js&"
export * from "./EmailRendering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1e160",
  null
  
)

export default component.exports